import { gql } from 'graphql-request';

export const USER_INSIDE_AREA_FIELDS = gql`
  fragment UserInsideAreaFields on UserInsideAreaDto {
    userId
    fullName
    email
    avatar
    role
    entryTime
    durationMinutes
    isInside
    exitTime
    projectId
    geofenceId
  }
`;

export const getUsersInsideArea = gql`
  query getUsersInsideArea($filter: UsersInsideAreaFilterInput!) {
    getUsersInsideArea(filter: $filter) {
      ...UserInsideAreaFields
    }
  }
  ${USER_INSIDE_AREA_FIELDS}
`;

const UsersInsideAreaGraphQL = {
  queries: { getUsersInsideArea },
};

export default UsersInsideAreaGraphQL;
